var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es10.js.map
